<template>
  <div class="row h-100">
    <div class="col-12 h-100">
      <div class="poppins h-100 d-flex flex-column" style="position: relative">
        <!-- <div class="small-id-text">ID: {{ this.$route.params.id }}</div> -->
        <div class="d-flex justify-content-end mb-3 pb-1">
          <a
            v-if="isCompletedReports"
            class="zip-link"
            :href="`${localBasePath}/api/v1/reports/case/${$route.params.id}/zip?authorization=${access_token_link}`"
            target="_blank"
          >
            {{ 'Download zip' | i18n }}
          </a>
          <b-button variant="primary" size="lg" class="pl-4 pr-4" :disabled="disabledSave" @click="saveCaseDetails">
            {{ 'save' | i18n }}
          </b-button>
        </div>
        <Loader v-if="!caseLoaded" />
        <div v-else class="overflow-x-hidden overflow-auto pr-1 flex1">
          <div style="position: relative">
            <BlockHeader name="Details" class="mt-0" />
            <div class="row">
              <div class="col-lg-8 col-sm-12 col-xs-12">
                <Input v-model="caseData.title" form-group-id="Title" placeholder="Title" :required="true" />
              </div>
              <div class="col-lg-4 col-sm-12 col-xs-12">
                <Input v-model="caseData.caseNumberString" form-group-id="Case number" placeholder="Case number" />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-xs-12">
                <Select
                  v-model="caseData.team.id"
                  :on-change="
                    () => {
                      caseData.user.id = null;
                    }
                  "
                  :options="teamOptions"
                  form-group-id="Team"
                  placeholder="Team"
                />
              </div>
              <div class="col-lg-4 col-sm-12 col-xs-12">
                <Select
                  v-model="caseData.user.id"
                  :options="usersOptions"
                  form-group-id="User Responsible"
                  placeholder="User Responsible"
                  :required="true"
                />
              </div>
              <div class="col-lg-4 col-sm-12 col-xs-12">
                <Radio v-model="caseData.status" :options="statusOptions" placeholder="Status" :required="true" small form-group-id="Status" />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="caseData.numberSortCriterium"
                  type="number"
                  form-group-id="Number Sort Criterium"
                  placeholder="Number Sort Criterium"
                />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="caseData.alphanumericSortCriterium"
                  form-group-id="Alphanumeric Sort Criterium"
                  placeholder="Alphanumeric Sort Criterium"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <DateTime v-model="caseData.dateDeal" type="date" placeholder="Schedule a date" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.groupingCriteria" form-group-id="Grouping criteria" placeholder="Grouping criteria" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.referenceOrInfo" form-group-id="referenceOrInfo" :placeholder="'Reference / Info' | i18n" />
              </div>
            </div>
          </div>
          <div>
            <BlockHeader name="Translation" />
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Select v-model="caseData.translateLanguage" :options="languageOptions" form-group-id="Language" placeholder="Language" />
              </div>
            </div>
          </div>
          <div>
            <BlockHeader name="Report Recipients" />
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.email" form-group-id="Report Recipient" placeholder="Report Recipient" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.emailCC" :tileSize="14" form-group-id="Report Recipient CC" placeholder="Report Recipient CC" />
              </div>
            </div>
          </div>
          <div>
            <BlockHeader name="Customer" class="mt-0" />
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.customerName" form-group-id="customerName" :placeholder="'Name' | i18n" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="caseData.customerStreetCityCountry"
                  form-group-id="customerStreetCityCountry"
                  :placeholder="'Address (Street, Zip Code City, Country)' | i18n"
                />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.customerTelefoneContact" form-group-id="customerTelefoneContact" :placeholder="'Phone No' | i18n" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.customerMobileContact" form-group-id="customerMobileContact" :placeholder="'Mobile Phone No' | i18n" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.customerEmailAddress" form-group-id="customerEmailAddress" :placeholder="'E-Mail Address' | i18n" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.customerServiceHours" form-group-id="customerServiceHours" :placeholder="'Service hours' | i18n" />
              </div>
            </div>
          </div>
          <div>
            <BlockHeader name="Point of service" />
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.pointOfServiceName" form-group-id="pointOfServiceName" :placeholder="'Name' | i18n" />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="caseData.pointOfServiceStreetCityCountry"
                  form-group-id="pointOfServiceStreetCityCountry"
                  :placeholder="'Address (Street, Zip Code City, Country)' | i18n"
                />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="caseData.pointOfServiceTelefoneContact"
                  form-group-id="pointOfServiceTelefoneContact"
                  :placeholder="'Phone No' | i18n"
                />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="caseData.pointOfServiceMobileContact"
                  form-group-id="pointOfServiceMobileContact"
                  :placeholder="'Mobile Phone No' | i18n"
                />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="caseData.pointOfServiceEmailAddress"
                  form-group-id="pointOfServiceEmailAddress"
                  :placeholder="'E-Mail Address' | i18n"
                />
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <Input v-model="caseData.pointOfServiceHours" form-group-id="pointOfServiceHours" :placeholder="'Service hours' | i18n" />
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex align-items-center">
              <BlockHeader name="Reports" />
              <b-button v-if="caseData.status !== CASE_STATUSES.FINISHED" variant="primary" size="sm" class="pl-4 pr-4 ml-3" @click="createNewReport">
                {{ 'create_new_report' | i18n }}
              </b-button>
            </div>
            <div>
              <div class="statuses-block">
                <div class="status-block">
                  <div class="dot active-status" />
                  <div class="status-name">
                    {{ 'In Progress' | i18n }}
                  </div>
                </div>
                <div class="status-block">
                  <div class="dot finished-status" />
                  <div class="status-name">
                    {{ 'Completed' | i18n }}
                  </div>
                </div>
              </div>
              <Table
                :update="loadReports"
                :columns="columns"
                :rows="reports"
                :filter="filter"
                :update-filter="updateFilter"
                :loading-instance="loadingInstance"
                :set-loading-instance="setLoadingInstance"
                tableName="caseDetailsTable"
              />
            </div>
          </div>
          <div v-if="selectedTemplate">
            <BlockHeader name="Template Details" />
            <Group
              v-for="group in selectedTemplate.groups"
              :key="group.id"
              :group="group"
              :set-field-value="setFieldValue"
              :fields-value="fieldsValue"
              :lists="lists"
              :getFileURL="getFileURL"
              :getFile="getFile"
              groupName="Group"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

import Input from '../../common/input';
import Select from '../../common/select';
import Radio from '../../common/radio';
import PageHeader from '../../common/page-header';
import BlockHeader from '../../common/block-header';
import Loader from '../../common/loader';
import Table from '../../common/table';
import DateTime from '../../common/date-time';

import Group from './components/group';
import GenerateDocxReport from './generate-docx-report-submit-modal';

import { BIconArrowRightShort } from 'bootstrap-vue';

import { ReportsMixin, NotificationMixin, ApiMixin, ListMixin, AuthStorageMixin } from '../../../../mixins';
import {
  CASE_STATUSES,
  TRANSLATE_LANGUAGE,
  REPORT_STATUSES,
  VALIDATION_RULES,
  ENTRY_TYPES_FILES,
  DOCX_CONVERT_ERROR,
} from '../../../../../../../constants';

export default {
  name: 'CaseDetails',
  components: { Input, PageHeader, Loader, Select, BlockHeader, Table, Group, Radio, GenerateDocxReport, DateTime },
  mixins: [ReportsMixin, NotificationMixin, ApiMixin, ListMixin, AuthStorageMixin],
  beforeRouteLeave(to, from, next) {
    if (!this.changed) {
      return next();
    }
    const answer = window.confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  data: function () {
    return {
      CASE_STATUSES,
      changed: false,
      fieldTrack: false,
      fieldsValue: {},
      caseData: {},
      teams: [],
      lists: [],
      reports: [],
      access_token_link: '',
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'updatedAt',
        sortOrder: 'desc',
      },
      loadingInstance: null,
      isCompletedReports: false,
      caseLoaded: false,
      statusOptions: Object.values(CASE_STATUSES).map((item) => ({
        value: item,
        text: this.$translate(item),
      })),
      languageOptions: Object.keys(TRANSLATE_LANGUAGE).map((i) => ({ value: TRANSLATE_LANGUAGE[i], text: this.$translate(i) })),
      columns: [
        {
          field: 'status',
          title: '',
          key: '1',
          width: 0,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const cellData = row[column.field];
            const color = (() => {
              switch (cellData) {
                case REPORT_STATUSES.IN_PROGRESS:
                  return 'active';
                case REPORT_STATUSES.COMPLETED:
                  return 'finished';
              }
            })();
            return <div class={`status-cell ${color}-status`}></div>;
          },
        },
        {
          field: 'createdAt',
          title: this.$translate('Created At'),
          key: '2',
          sortBy: '',
        },
        {
          field: 'createdByEmail',
          title: this.$translate('Created by user'),
          key: '3',
        },
        {
          field: 'updatedAt',
          title: this.$translate('Last Update'),
          key: '4',
          sortBy: 'desc',
        },
        {
          field: 'download',
          title: '',
          key: '5',
          width: 50,
          renderBodyCell: ({ row }, h) => {
            return (
              <div class="download-buttons">
                <div class="download-button" on-click={() => this.download(row.id, 'zip')}>
                  zip
                </div>
                <div
                  class={`download-button ${!row.pdf ? 'download-button-disabled' : ''}`}
                  on-click={() => (row.pdf ? this.download(row.id, 'pdf') : null)}
                >
                  pdf
                </div>
                <div class="download-button" on-click={() => this.download(row.id, 'xml')}>
                  xml
                </div>
                <div class="download-button" on-click={() => this.download(row.id, 'json')}>
                  json
                </div>
                <div class={`download-button ${!row.pdf ? 'download-button-disabled' : ''}`} on-click={() => this.docxActions(row)}>
                  docx
                </div>
                <GenerateDocxReport download={this.download} row={row} reports={this.reports} setReports={this.setReports} />
              </div>
            );
          },
        },
        {
          field: 'details',
          title: '',
          key: '6',
          width: 50,
          renderBodyCell: ({ row }, h) => {
            return (
              <div class="details-action" on-click={() => this.goToReportDetails(row.id)}>
                <BIconArrowRightShort />
              </div>
            );
          },
        },
      ],
    };
  },
  computed: {
    usersOptions: function () {
      const teamID = this.caseData.team.id;
      const team = this.teams.find((i) => i.id === teamID) || [];
      const users = team.users;
      return users ? users.map((item) => ({ value: item.id, text: item.name })) : [];
    },
    teamOptions: function () {
      return this.teams.map((item) => ({ value: item.id, text: item.name }));
    },
    localBasePath: function () {
      return axios.defaults.baseURL;
    },
    disabledSave: function () {
      return !this.caseData.title || !(this.caseData.user && this.caseData.user.id);
    },
    selectedTemplate: function () {
      if (!this.caseData.template) {
        return null;
      }
      const template = this.caseData.template;
      const groups = [];
      const groupsFields = {};

      template.fields.map((f) => {
        if (!groupsFields[f.groupId]) {
          groupsFields[f.groupId] = [];
        }
        f.required = f.rules.some((r) => r.name === VALIDATION_RULES.REQUIRED);
        groupsFields[f.groupId].push(f);
      });

      template.groups.map((g) => {
        const data = {
          name: g.name,
          id: g.id,
          fields: groupsFields[g.id],
        };
        groups.push(data);
      });

      return {
        name: template.name,
        id: template.id,
        groups,
      };
    },
  },
  async created() {
    const auth = this.authStorageService.getAuth();
    this.access_token_link = auth.access_token_link;

    this.loadTeamsLookup();
    this.loadCase();
    const lists = await this.listService.get();
    this.lists = lists.data;
  },
  watch: {
    caseData: {
      handler: function () {
        if (this.caseLoaded) {
          this.changed = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    async docxActions(row) {
      if (!row.pdf) return;
      if (row.docx && row.docx !== DOCX_CONVERT_ERROR) {
        this.download(row.id, 'docx');
      } else {
        this.$root.$emit('bv::show::modal', `submit-generate-docx-${row.id}`);
      }
    },
    setReports(newReports) {
      this.reports = newReports;
    },
    getFileURL(id) {
      return `${this.localBasePath}/api/v1/reports/cases/${this.caseData.id}/files/${id}?authorization=${this.access_token_link}`;
    },
    async getFile(id) {
      try {
        await axios(this.getFileURL(id));
        window.open(this.getFileURL(id), '_blank');
      } catch (error) {
        this.showNotification({ type: 'error', message: this.$translate('file_do_not_uploaded') });
      }
    },
    setFieldValue(field, value) {
      const isFile = ENTRY_TYPES_FILES.includes(field.entryType);
      if (this.fieldTrack) {
        this.changed = true;
      }
      this.fieldsValue[field.id] = value;
      if (isFile && !value) {
        this.fieldsValue[field.key] = value;
      }
    },
    download(id, type) {
      window.open(`${this.localBasePath}/api/v1/reports/report/${id}/${type}?authorization=${this.access_token_link}`, '_blank');
    },
    async saveCaseDetails() {
      try {
        console.log(this.fieldsValue, 'this.fieldsValue');
        const fields = [];
        this.selectedTemplate.groups.forEach((g) => {
          if (g.fields) {
            g.fields.forEach((f) => {
              fields.push({
                ...f,
                value: this.fieldsValue[f.id],
                isAttachFileToEmail: Object.hasOwn(this.fieldsValue || {}, `${f.key}_attachToEmail`)
                  ? this.fieldsValue[`${f.key}_attachToEmail`]
                  : f.isAttachFileToEmail,
              });
            });
          }
        });

        await this.reportsService.updateCase({ ...this.caseData, fields });
        this.showNotification({ type: 'success', message: this.$translate('success') });
        this.changed = false;
        this.$router.push({ name: 'cases' });
      } catch (err) {
        console.log(err, 'err');
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    goToReportDetails(id) {
      this.$router.push({ name: 'case-report-details', params: { id: this.caseData.id, reportId: id } });
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async loadReports() {
      try {
        this.startLoading();
        const response = await this.reportsService.getReportsPage(this.filter, this.$route.params.id);
        this.isCompletedReports = response.data.some((i) => i.status === REPORT_STATUSES.COMPLETED);
        response.data = response.data.map((item) => ({
          ...item,
          createdByEmail: item.createdBy ? item.createdBy.email : '',
          createdAt: moment(item.createdAt).format('DD.MM.YY HH:mm'),
          updatedAt: moment(item.updatedAt).format('DD.MM.YY HH:mm'),
        }));
        this.reports = response.data;
        this.stopLoading();
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async loadCase() {
      try {
        const response = await this.reportsService.getCaseById(this.$route.params.id);
        this.caseData = response.data;
        this.fieldsValue = {
          ...this.caseData.report.fields,
          ...this.caseData.fields,
        };
        setTimeout(() => {
          this.caseLoaded = true;
        }, 100);
        setTimeout(() => {
          this.fieldTrack = true;
        }, 500);
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async loadTeamsLookup() {
      const response = await this.reportsService.getTeams();
      this.teams = response;
    },
    createNewReport() {
      this.$router.push({ name: 'case-new-report', params: { id: this.caseData.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  overflow-y: visible;
  max-height: 100%;
}
.inputs-block {
  padding-left: 20px;
  padding-right: 20px;
}

::v-deep .status-cell {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  border-radius: 0 2px 2px 0;
}

::v-deep .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
::v-deep .active-status {
  background-color: rgb(37, 154, 43);
}
::v-deep .inprogress-status {
  background-color: rgb(239, 255, 15);
}
::v-deep .finished-status {
  background-color: rgb(90, 98, 107);
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  width: 100%;
}

.status-block {
  display: flex;
  margin-left: 20px;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.status-name {
  margin-left: 10px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: auto;
}

::v-deep .download-buttons {
  display: flex;
}
::v-deep .download-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  cursor: pointer;
}
::v-deep .download-button-disabled {
  opacity: 0.5;
}

::v-deep .zip-link {
  padding: 8px 24px;
  cursor: pointer;
  display: inline-block;
  outline: none;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  text-decoration: none;
  margin-right: 25px;

  background: #edf8fe;
  border: 2px solid #afd8ff;
  border-radius: 4px;
  color: #318dff;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}
</style>
